import { withStyles } from '@material-ui/core/styles';
import styles from './ChatStatusIndicator.styles';
import ChatStatusIndicator from './ChatStatusIndicator';

export default withStyles(styles)(ChatStatusIndicator);
